import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

// 🔹 Images (SAFE names)
import img1 from "../../Assets/9th_slider/cat-1.png";
import img2 from "../../Assets/9th_slider/cat-3.png";
import img3 from "../../Assets/9th_slider/cat-4.png";
import img4 from "../../Assets/9th_slider/cat-5.png";
import img5 from "../../Assets/9th_slider/cat-6.png";
import img6 from "../../Assets/9th_slider/cat-8.png";
import Secound_slider from "./Secound_slider";
import Secoundcarrercomic from "../slider/Secoundcarrercomic";

const categories = [
  { img: img1, title: "Must Haves" },
  { img: img2, title: "Sport Nutrition" },
  { img: img3, title: "Vitamins & Supplements" },
  { img: img4, title: "Skin Care" },
  { img: img5, title: "Diabetes Essentials" },
  { img: img6, title: "Heart Care" },
];

const Personal_slider = () => {
  return (
    <>
    <section className="w-full bg-white py-10">
      <div className="max-w-7xl mx-auto px-4">

        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-[30px] font-medium text-black">
            Personal Care
          </h2>

          <div className="hidden sm:flex gap-3">
            <button className="w-[50px] h-[50px] rounded-full bg-[#187685] flex items-center justify-center">
              <ChevronLeft className="text-white w-6 h-6" />
            </button>
            <button className="w-[50px] h-[50px] rounded-full bg-[#187685] flex items-center justify-center">
              <ChevronRight className="text-white w-6 h-6" />
            </button>
          </div>
        </div>

        {/* Categories */}
        <div className="flex gap-6 overflow-x-auto pb-2">
          {categories.map((item, index) => (
            <div key={index} className="w-[175px] flex-shrink-0 text-center">
              <div className="w-[175px] h-[175px] rounded-xl bg-[#FAFAFA] flex items-center justify-center mb-3">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-[125px] h-[125px] object-contain"
                />
              </div>

              <p className="text-[17px] text-[#060A0B]">
                {item.title}
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
    {/* <Secound_slider/> */}
    <Secoundcarrercomic />
    
    </>
  );
};

export default Personal_slider;
